import React from 'react'
import loaderVideoAnim from '../Assets/ainfra/videos/loader.mp4'

const Loader = () => {
    return (
        <div className='loader-container'>
            <video autoPlay muted loop className='loader-video' >
                <source src={loaderVideoAnim} type="video/mp4" />
            </video>
        </div>
    )
}

export default Loader